import { DialogContent, DialogTitle } from "@mui/material";
import { observer } from "mobx-react";
import { useTranslation } from "react-i18next";
import styles from "./index.module.scss";
import UKDialog from "@/common-components-src/components/UKDialog/index";
import ApplySuccess from "@/app/csr-src/assets/icons/ApplySuccess.svg";
import CommonButton from "../commonButton";

interface applySuccessModalProps {
  isOpen: boolean;
  closeHandler: () => void;
  viewDetailHandler: () => void;
}

const applySuccessModal: React.FC<applySuccessModalProps> = observer(({ isOpen, closeHandler, viewDetailHandler }) => {
  const { t } = useTranslation();

  // 跳转首页
  const jumpToHome = () => {
    window.location.href = "/";
  };

  return (
    <UKDialog
      open={isOpen}
      onClose={closeHandler}
      sx={{
        "& .MuiDialog-paper": {
          width: "520px", // 设置自定义宽度
        },
      }}
    >
      <DialogTitle>
        <div className={styles.apply_success_modal_title}>
          <ApplySuccess className={styles.apply_success_icon} />
          {t("order.orderDetail.applySuccessModal.modalTitle")}
        </div>
      </DialogTitle>
      <DialogContent>
        <div className={styles.apply_success_content}>
          {/* {t("order.orderDetail.applySuccessModal.modalContent")} */}
          Your return request has been successfully submitted. Please view details to see what’s next.
        </div>
        <div className={styles.oper_wrap}>
          <CommonButton
            variant="outlined"
            onClick={jumpToHome}
            style={{
              marginRight: "12px",
            }}
          >
            {/* {t("order.orderDetail.applySuccessModal.shoppingBtn")} */}
            Go shopping
          </CommonButton>
          <CommonButton variant="contained" onClick={viewDetailHandler}>
            {t("order.orderDetail.applySuccessModal.detailBtn")}
          </CommonButton>
        </div>
      </DialogContent>
    </UKDialog>
  );
});

export default applySuccessModal;
